import authApiService from "./userApiService"; // Ensure this is your axios instance with interceptors
import { toast } from "react-hot-toast";
export const userManagementService = {
  // Get all users
  async getAllUsers() {
    try {
      const response = await authApiService.get("/profile/users");
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  async getSingleUser(userId) {
    try {
      const response = await authApiService.get(`/profile/users/${userId}`);
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },
  // Add new user (with optional profile picture)
  async addUser(userData) {
    try {
      const formData = new FormData();
      
      // Add required fields
      formData.append("Name", userData.name);
      formData.append("Password", userData.password);
      formData.append("Emailid", userData.email);
      formData.append("Contact", userData.phone || "");
      formData.append("Role", userData.role);
      formData.append("ProfileImageName", userData.profileImage || "");
      
      // Add profile picture if provided
      // if (userData.profileImage && userData.profileImage instanceof File) {
      //   formData.append("propic", userData.profileImage);
      // }

      const response = await authApiService.post("/profile/add-user", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      return { success: true, data: response.data };
    } catch (error) {
      console.log("error",error)
      return handleError(error);
    }
  },

  // Update user (by ID with optional profile picture)
  async updateUser(id, userData) {
    try {
      const formData = new FormData();
      
      // Add required fields
      formData.append("update_id", id);
      formData.append("Name", userData.name);
      formData.append("Emailid", userData.email);
      formData.append("Contact", userData.phone || "");
      formData.append("Role", userData.role);
      formData.append("ProfileImageName", userData.profileImage || "");
      // Add profile picture if provided
      // if (userData.profileImage && userData.profileImage instanceof File) {
      //   formData.append("propic", userData.profileImage);
      // }

      const response = await authApiService.put("/profile/update-user", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      return { success: true, data: response.data };
    } catch (error) {
      console.error("API Error:", error);
    
      let message = "User already exists!";
      let status = 500;
    
      if (error?.response) {
        status = error.response.status;
        message =
          error.response.data?.body?.message ||
          error.response.data?.error ||
          `HTTP ${status} Error`;
      } else if (error?.request) {
        message = "Network error. Please check your connection.";
        status = 0;
      } else {
        message = error.message || "An unexpected error occurred";
      }
    
      toast.error(`Failed to update user: ${message}`);
    
      return {
        success: false,
        message,
        status,
        originalError: error,
      };
    }    
  },

  // Delete user by ID
  async deleteUser(id) {
    try {
      const response = await authApiService.delete("/profile/delete-user", {
        data: { delete_id: id }
      });
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  // Update password for user
  async updatePassword(id, passwordData) {
    try {
      const response = await authApiService.put("/profile/update-password", {
        update_pass_id: id,
        password: passwordData.password,
        cpassword: passwordData.confirmPassword
      });
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  // Update mail status
  async updateMailStatus(profileId, status) {
    try {
      const response = await authApiService.put("/profile/update-mail-status", {
        profileId: profileId,
        status: status.toLowerCase() // Convert to lowercase as backend expects 'enabled'/'disabled'
      });
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  // Get roles
  async getRoles() {
    try {
      const response = await authApiService.get("/profile/roles");
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  // Get users with enabled mail status
  async getEnabledMailUsers(includeAdmin = false) {
    try {
      const params = includeAdmin ? { includeAdmin: 'true' } : {};
      const response = await authApiService.get("/profile/enabled-mail-users", { params });
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  // Alternative methods using RESTful endpoints (if you prefer these)
  
  // Update user using RESTful route
  async updateUserRest(id, userData) {
    try {
      const formData = new FormData();
      
      // Add fields
      formData.append("Name", userData.name);
      formData.append("Emailid", userData.email);
      formData.append("Contact", userData.phone || "");
      formData.append("Role", userData.role);
      
      // Add profile picture if provided
      if (userData.profileImage && userData.profileImage instanceof File) {
        formData.append("propic", userData.profileImage);
      }

      const response = await authApiService.put(`/profile/users/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  // Delete user using RESTful route
  async deleteUserRest(id) {
    try {
      const response = await authApiService.delete(`/profile/users/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  // Update password using RESTful route
  async updatePasswordRest(id, passwordData) {
    try {
      const response = await authApiService.put(`/profile/users/${id}/password`, {
        password: passwordData.password,
        cpassword: passwordData.confirmPassword
      });
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  },

  // Update mail status using RESTful route
  async updateMailStatusRest(profileId, status) {
    try {
      const response = await authApiService.put(`/profile/users/${profileId}/mail-status`, {
        status: status.toLowerCase()
      });
      return { success: true, data: response.data };
    } catch (error) {
      return handleError(error);
    }
  }
};

function handleError(error) {
  console.error("API Error:", error);

  let message = "Something went wrong";
  let status = 500;

  if (error?.response) {
    // Backend responded with an error status
    status = error.response.status;

    // Prioritize common message fields or fallback
    message =
      error.response.data?.message ||
      error.response.data?.error ||
      `HTTP ${status} Error`;
  } else if (error?.request) {
    // Request was made but no response received (network error or timeout)
    message = "Network error. Please check your connection.";
    status = 0;
  } else {
    // Something went wrong in setting up the request
    message = error?.message || "An unexpected error occurred";
  }

  return {
    success: false,
    message,
    status,
    originalError: error,
  };
}
